import React from 'react';
import { Github, Youtube, Facebook, Linkedin, Link as LinkIcon } from 'lucide-react';
import { SOCIAL_LINKS } from '../../config/site';

const ICONS = { github: Github, youtube: Youtube, facebook: Facebook, linkedin: Linkedin };

const SocialLinks = ({ className = '' }) => (
    <div className={`flex items-center gap-6 ${className}`}>
        {SOCIAL_LINKS.map(({ id, label, url }) => {
            const Icon = ICONS[id] || LinkIcon;
            return (
                <a
                    key={id}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="text-slate-400 dark:text-slate-500 hover:text-slate-900 dark:hover:text-white transition-colors"
                >
                    <Icon className="w-5 h-5" />
                </a>
            );
        })}
    </div>
);

export default SocialLinks;
